const STORAGE_KEY = "gxp_frontend_api_logs";
const MAX_LOGS = 200;

const safeClone = (value) => {
  if (value === undefined) return null;
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return String(value);
  }
};

const readLogs = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeLogs = (logs) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(logs.slice(-MAX_LOGS)));
  } catch {
    // Swallow storage errors; logging should not break app flow.
  }
};

export const appendFrontendApiLog = (event, payload = {}) => {
  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    timestamp: new Date().toISOString(),
    event,
    payload: safeClone(payload),
  };

  const nextLogs = [...readLogs(), entry];
  writeLogs(nextLogs);

  if (typeof window !== "undefined") {
    window.__GXP_FRONTEND_API_LOGS__ = nextLogs.slice(-MAX_LOGS);
  }

  return entry;
};

export const getFrontendApiLogs = () => readLogs();

export const clearFrontendApiLogs = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  if (typeof window !== "undefined") {
    window.__GXP_FRONTEND_API_LOGS__ = [];
  }
};

